import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
    id: "planes",
    class: "platforms"
};
var _hoisted_2 = { class: "platforms-list row justify-content-center" };
var _hoisted_3 = { class: "card" };
var _hoisted_4 = { class: "card-header" };
var _hoisted_5 = { class: "text-center" };
var _hoisted_6 = { class: "card-body" };
var _hoisted_7 = { class: "price text-center" };
var _hoisted_8 = { class: "d-flex justify-content-center" };
var _hoisted_9 = ["onClick"];
import { ref, onMounted } from 'vue';
import { getPlatforms } from '@/api/admin/platforms';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomePlans',
    setup: function (__props) {
        var _this = this;
        var platforms = ref([]);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                loadPlatforms();
                return [2 /*return*/];
            });
        }); });
        var loadPlatforms = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, getPlatforms({ per_page: 4, page: 1 })];
                    case 1:
                        response = _b.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 3];
                        _a = platforms;
                        return [4 /*yield*/, response.data.data];
                    case 2:
                        _a.value = _b.sent();
                        return [3 /*break*/, 4];
                    case 3: throw new Error('Error al cargar las plataformas');
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _b.sent();
                        console.error(error_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platforms.value, function (pl) {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "platform-card col-xs-12 col-md-6 col-lg-3 py-2",
                            key: pl.id
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("h3", _hoisted_5, _toDisplayString(pl.name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("p", _hoisted_7, "$us " + _toDisplayString(pl.cost_per_account), 1),
                                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "price-info text-center" }, [
                                        _createElementVNode("small", null, "/ cada mes")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("button", {
                                            class: "btn btn-outline-primary",
                                            onClick: function ($event) { return (_ctx.$router.push({ name: 'Platforms.show', params: { id: pl.id } })); }
                                        }, [
                                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "me-2" }, "¡Únete ahora!", -1)),
                                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'right-to-bracket'] })
                                        ], 8, _hoisted_9)
                                    ])
                                ])
                            ])
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
});
